import React from "react";
import PropTypes from "prop-types";

import styles from "./TopicHeader.module.css";

const TopicHeader = ({ data = {} }) => {
  const text = data?.text;
  return text ? <p className={styles.header}>{text}</p> : null;
};

export default TopicHeader;

TopicHeader.propTypes = {
  data: PropTypes.object,
};
